export const PROFILE_COMPLETION_ITEMS = [
  {
    key: 'birthday',
    label: 'Birthday',
    href: '/edit',
    description: 'We use your age to match you with compatible language partners.',
  },
  {
    key: 'location',
    label: 'Pinned location',
    href: '/edit',
    description: 'Your city helps us find learners and native speakers near you.',
  },
  {
    key: 'native_language',
    label: 'At least 1 native language',
    href: '/my_languages',
    description: 'Add a language you speak fluently so others can learn from you.',
  },
  {
    key: 'learning_language',
    label: 'At least 1 learning language',
    href: '/my_languages',
    description: 'Add a language you are learning so we can find teachers for you.',
  },
]

export function getIncompleteProfileItems(profileCompletion) {
  if (!profileCompletion) return []

  return PROFILE_COMPLETION_ITEMS.filter((item) => profileCompletion[item.key])
}

export function isProfileIncomplete(profileCompletion) {
  if (!profileCompletion) return false

  return profileCompletion.incomplete === true
}
